import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import {
  Alert,
  Col,
  Row,
  Button,
  Card,
  FormInput,
  FormInputText,
  FormInputSelect,
  ButtonContainer,
  DetailList
} from 'camino-react'

import { cloudhelpPost, cloudhelpPatch } from 'Utilities/CloudHelp'

class TicketQueueForm extends React.Component {
  constructor (props) {
    super(props)

    const { ticketQueue, users } = props
    this.state = {
      userOptions: _.sortBy(_.map(users, user => ({ label: user.name, value: user.id })), 'label'),
      fields: {
        queueName: ticketQueue.name,
        managerID: ticketQueue.manager_id,
        queueUsers: ticketQueue.users || []
      },
      submitButton: {
        buttonText: 'Save',
        disabled: false
      },
      alert: {
        showAlert: false,
        alertText: '',
        alertType: ''
      }
    }
  }

  handleFieldValue = (fieldName, value) => {
    this.setState((prevState) => {
      const { fields } = prevState
      const newFields = Object.assign({}, fields, { [fieldName]: value })

      return (
        { fields: newFields }
      )
    })
  }

  handleSelectUser = (fieldName, value) => {
    const { users } = this.props
    const { fields: { queueUsers } } = this.state
    let selectedUser = {}
    let userQueues = []

    if (!_.isEmpty(value)) {
      selectedUser = _.find(users, ['id', value[value.length - 1].value])
      userQueues = selectedUser.ticket_queues
    }

    if (!_.isEmpty(userQueues) && !queueUsers.includes(value[value.length - 1])) {
      // eslint-disable-next-line no-alert
      window.alert(`${selectedUser.name} is already assigned to: ${_.map(userQueues, queue => `\n- ${queue.name}`)}`)
    }
    this.handleFieldValue(fieldName, value)
  }

  displayAlert = (type, text) => (
    this.setState({
      alert: {
        alertText: `Ticket Queue ${text}`,
        alertType: `${type}`,
        showAlert: true
      },
      submitButton: {
        buttonText: 'Save',
        disabled: false
      }
    })
  )

  submit () {
    const {
      fields: {
        queueName,
        queueUsers,
        managerID
      }
    } = this.state

    const queueUsersIDs = _.map(queueUsers, user => (user.value))
    const postData = {
      ticket_queue: {
        name: queueName,
        manager_id: managerID,
        users: queueUsersIDs
      }
    }

    this.setState({
      submitButton: {
        buttonText: 'Saving Queue',
        disabled: true
      }
    })

    this.makeRequest(postData)
      .then((response) => {
        this.displayAlert('success', response.data.result)
        window.location.href = response.data.redirect_url
      })
      .catch(error => (
        this.displayAlert('error', error.data.errors)
      ))
  }

  makeRequest (data) {
    const { ticketQueue } = this.props

    if (ticketQueue.id) { return cloudhelpPatch(`/ticket_queues/${ticketQueue.id}`, data) }

    return cloudhelpPost('/ticket_queues', data)
  }

  render () {
    const {
      userOptions,
      fields: {
        queueName,
        managerID,
        queueUsers
      },
      submitButton: {
        buttonText,
        disabled
      },
      alert: {
        alertText,
        alertType,
        showAlert
      }
    } = this.state

    return (
      <div>
        <Row>
          <Col>
            { showAlert && (
              <Alert type={alertType}>
                {alertText}
              </Alert>
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            <DetailList
              list={[
                {
                  title: 'Input name and select manager',
                  content: ''
                }
              ]}
            />
          </Col>
          <Col>
            <Card allowOverflow>
              <FormInput label="Queue name">
                <FormInputText
                  value={queueName}
                  onValue={value => this.handleFieldValue('queueName', value)}
                />
              </FormInput>
              <FormInput label="Manager">
                <FormInputSelect
                  options={userOptions}
                  value={_.find(userOptions, ['value', managerID])}
                  onValue={value => this.handleFieldValue('managerID', value)}
                  isLoading={_.isEmpty(userOptions)}
                />
              </FormInput>
            </Card>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <DetailList
              list={[
                {
                  title: 'Select queue users',
                  content: 'Those users will be added to ticket queue'
                }
              ]}
            />
          </Col>
          <Col>
            <Card allowOverflow>
              <FormInput label="Queue users">
                <FormInputSelect
                  isMulti
                  value={queueUsers}
                  options={userOptions}
                  onValue={value => this.handleSelectUser('queueUsers', value)}
                  isLoading={_.isEmpty(userOptions)}
                />
              </FormInput>
            </Card>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <ButtonContainer center spaced>
              <a href="/ticket_queues" className="button button--outline">
                Cancel
              </a>
              <Button onClick={() => this.submit()} disabled={disabled}>
                {buttonText}
              </Button>
            </ButtonContainer>
          </Col>
        </Row>
      </div>
    )
  }
}

TicketQueueForm.defaultProps = {
  ticketQueue: {
    name: '',
    manager_id: null,
    users: []
  },
  users: []
}

TicketQueueForm.propTypes = {
  ticketQueue: PropTypes.shape({
    name: PropTypes.string,
    manager_id: PropTypes.number,
    users: PropTypes.arrayOf(PropTypes.object)
  }),
  users: PropTypes.arrayOf(PropTypes.object)
}

export default TicketQueueForm
